<app-superadmin-navbar *ngIf="!modoAdminHotel"></app-superadmin-navbar>
<app-navbar *ngIf="modoAdminHotel"></app-navbar>
<div class="container" #container>

    <!-- Loading Spinner Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="loading-container">
            <div class="spinner-animation"></div>
            <p class="loading-message">{{ loadingMessage }}</p>
        </div>
    </div>

    <!-- Formulario Anfitrion -->
    <div class="DatosAnfitrion ">
        <h2>Datos del anfitrión test</h2>
        <div class="form-group">
            <label for="hostName">Nombre:</label>
            <input type="text" id="hostName" [(ngModel)]="anfitrion.name" />
        </div>
        <div class="form-group">
            <label for="hostLastName">Apellido:</label>
            <input type="text" id="hostLastName" [(ngModel)]="anfitrion.lastName" />
        </div>
        <div class="form-group">
            <label for="hostEmail">Email:</label>
            <input type="email" id="hostEmail" [(ngModel)]="anfitrion.email" />
        </div>
        <div class="form-group">
            <label for="hostPhone">Teléfono:</label>
            <input type="tel" id="hostPhone" [(ngModel)]="anfitrion.phone" />
        </div>
        <div class="form-group">
            <label for="hostDocumentType">Tipo de documento:</label>
            <select id="hostDocumentType" [(ngModel)]="anfitrion.documentType">
                <option value="">Seleccione...</option>
                <option *ngFor="let tipo of tiposDocumento" [value]="tipo.nombre">
                    {{ tipo.nombre }}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="hostDocumentNumber">Número de documento:</label>
            <input type="text" id="hostDocumentNumber" [(ngModel)]="anfitrion.documentNumber" />
        </div>
    </div>

    <!-- Formulario Alojamiento -->
    <div class="DatosAlojamiento">
        <h2>Datos del alojamiento</h2>
        <div class="form-group">
            <label for="name">Nombre:</label>
            <input type="text" id="name" [(ngModel)]="datoBasicos.name" />
        </div>
        <div class="form-group">
            <label for="email">Email:</label>
            <input type="email" id="email" [(ngModel)]="datoBasicos.email" />
        </div>
        <div class="form-group">
            <label for="phone">Teléfono:</label>
            <input type="tel" id="phone" [(ngModel)]="datoBasicos.phone" />
        </div>
        <div class="form-group">
            <label for="description">Descripción:</label>
            <textarea id="description" [(ngModel)]="datoBasicos.description"></textarea>
        </div>
        <div class="form-group">
            <label for="type">Tipo de alojamiento:</label>
            <select id="tiposAlojamiento" [(ngModel)]="datoBasicos.type">
                <option value="">Seleccione...</option>
                <option *ngFor="let tipo of tiposAlojamiento" [value]="tipo.nombre">
                    {{ tipo.nombre }}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="capacity">Capacidad total del alojamiento:</label>
            <input type="number" id="capacity" [(ngModel)]="datoBasicos.capacity" />
        </div>
        <div class="form-group">
            <label for="rooms">Número de habitaciones:</label>
            <input type="number" id="rooms" [(ngModel)]="datoBasicos.rooms" />
        </div>
    </div>

    <!-- Sección de Imágenes del Alojamiento -->
    <div class="DatosImagenes">
        <h2>Imágenes del alojamiento</h2>

        <!-- Área de subida de archivos -->
        <div class="upload-area" [class.dragover]="isDragOver" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onFilesDrop($event)">

            <div class="upload-content">
                <div class="upload-icon">📸</div>
                <p class="upload-text">
                    Arrastra las imágenes aquí o
                    <label for="file-input" class="upload-link">selecciona archivos</label>
                </p>
                <input type="file" id="file-input" multiple accept="image/*" (change)="onFilesSelected($event)"
                    style="display: none;">
                <p class="upload-info">
                    Formatos permitidos: JPG, PNG, WebP • Tamaño máximo: 5MB por imagen
                </p>
            </div>
        </div>

        <!-- Barra de progreso general -->
        <div class="upload-progress" *ngIf="uploadProgress.show">
            <div class="progress-info">
                <span>Subiendo imágenes... {{uploadProgress.uploaded}}/{{uploadProgress.total}}</span>
                <span>{{uploadProgress.percentage}}%</span>
            </div>
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="uploadProgress.percentage"></div>
            </div>
        </div>

        <!-- Lista de imágenes -->
        <div class="images-list" *ngIf="imagenesAlojamiento.length > 0">
            <h3>Imágenes seleccionadas ({{imagenesAlojamiento.length}})</h3>

            <div class="images-grid">
                <div class="image-item" *ngFor="let imagen of imagenesAlojamiento; let i = index">

                    <!-- Preview de la imagen -->
                    <div class="image-preview">
                        <img [src]="imagen.preview" [alt]="'Imagen ' + (i + 1)">

                        <!-- Overlay de estado -->
                        <div class="image-overlay" *ngIf="imagen.uploading || imagen.error">
                            <!-- Cargando -->
                            <div class="loading-spinner" *ngIf="imagen.uploading">
                                <div class="spinner"></div>
                                <span>Subiendo...</span>
                            </div>

                            <!-- Error -->
                            <div class="error-message" *ngIf="imagen.error && !imagen.uploading">
                                <div class="error-icon">❌</div>
                                <span>{{imagen.error}}</span>
                            </div>
                        </div>

                        <!-- Indicador de éxito -->
                        <div class="success-indicator" *ngIf="imagen.uploaded && !imagen.uploading">
                            <div class="success-icon">✅</div>
                        </div>
                    </div>

                    <!-- Información de la imagen -->
                    <div class="image-info">
                        <div class="image-name">{{imagen.file.name}}</div>
                        <div class="image-size">{{formatFileSize(imagen.file.size)}}</div>
                        <div class="image-status">
                            <span *ngIf="imagen.uploading" class="status uploading">Subiendo...</span>
                            <span *ngIf="imagen.uploaded" class="status uploaded">Subida</span>
                            <span *ngIf="imagen.error && !imagen.uploading" class="status error">Error</span>
                        </div>
                    </div>

                    <!-- Acciones -->
                    <div class="image-actions">
                        <!-- Botón para marcar como principal -->
                        <button type="button" class="btn btn-sm" [class.btn-primary]="i === imagenPrincipalIndex"
                            [class.btn-outline-primary]="i !== imagenPrincipalIndex" (click)="marcarComoPrincipal(i)"
                            [disabled]="!imagen.uploaded" title="Marcar como imagen principal">
                            {{i === imagenPrincipalIndex ? '⭐ Principal' : 'Marcar principal'}}
                        </button>

                        <!-- Botón para eliminar -->
                        <button type="button" class="btn btn-sm btn-danger" (click)="eliminarImagen(i)"
                            [disabled]="imagen.uploading" title="Eliminar imagen">
                            🗑️
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mensaje cuando no hay imágenes -->
        <div class="no-images" *ngIf="imagenesAlojamiento.length === 0">
            <div class="no-images-icon">🖼️</div>
            <p>No has agregado imágenes aún</p>
            <p class="text-muted">Las imágenes ayudan a mostrar mejor tu alojamiento</p>
        </div>

        <!-- Resumen de imágenes para el formulario -->
        <div class="images-summary" *ngIf="imagenesSubidas.length > 0">
            <h4>Resumen para envío</h4>
            <div class="summary-info">
                <p><strong>Total de imágenes:</strong> {{imagenesSubidas.length}}</p>
                <p><strong>Imagen principal:</strong> {{
                    (imagenesSubidas && imagenPrincipalIndex != null && imagenPrincipalIndex >= 0 &&
                    imagenesSubidas[imagenPrincipalIndex])
                    ? imagenesSubidas[imagenPrincipalIndex]?.file?.name
                    : 'No seleccionada'
                    }}</p>
            </div>
        </div>
    </div>

    <!-- Sección de Servicios Adicionales Extras -->
    <div class="DatosServicios">
        <h2>Servicios Adicionales Extras</h2>
        <p class="section-description">Servicios que tienen un costo adicional para los huéspedes</p>

        <!-- Botón para agregar servicio extra -->
        <div class="service-actions">
            <button type="button" class="btn btn-primary" (click)="agregarServicioExtra()">
                ➕ Agregar Servicio Extra
            </button>
        </div>

        <!-- Lista de servicios extras -->
        <div class="services-list" *ngIf="serviciosAdicionalesExtras.length > 0">
            <div class="service-item" *ngFor="let servicio of serviciosAdicionalesExtras; let i = index">
                <div class="service-row">
                    <div class="form-group service-name">
                        <label>Nombre del servicio:</label>
                        <input type="text" [(ngModel)]="servicio.service"
                            placeholder="Ej: Tour ecológico, almuerzos" />
                    </div>
                    <div class="form-group service-cost">
                        <label>Costo ($):</label>
                        <input type="number" [(ngModel)]="servicio.cost" min="0" placeholder="0" />
                    </div>
                    <div class="service-actions-row">
                        <button type="button" class="btn btn-sm btn-danger" (click)="eliminarServicioExtra(i)">
                            🗑️ Eliminar
                        </button>
                    </div>
                </div>
                <div class="service-id-info">
                    <small>ID: {{servicio.additional_id}} | Estado: {{servicio.status}}</small>
                </div>
            </div>
        </div>

        <!-- Mensaje cuando no hay servicios extras -->
        <div class="no-services" *ngIf="serviciosAdicionalesExtras.length === 0">
            <div class="no-services-icon">💰</div>
            <p>No has agregado servicios extras</p>
            <p class="text-muted">Los servicios extras generan ingresos adicionales</p>
        </div>
    </div>

    <!-- Sección de Servicios Adicionales Incluidos -->
    <div class="DatosServicios">
        <h2>Servicios Adicionales Incluidos</h2>
        <p class="section-description">Servicios incluidos en el precio base del alojamiento</p>

        <!-- Botón para agregar servicio incluido -->
        <div class="service-actions">
            <button type="button" class="btn btn-success" (click)="agregarServicioIncluido()">
                ➕ Agregar Servicio Incluido
            </button>
        </div>

        <!-- Lista de servicios incluidos -->
        <div class="services-list" *ngIf="serviciosAdicionalesIncluidos.length > 0">
            <div class="service-item-simple" *ngFor="let servicio of serviciosAdicionalesIncluidos; let i = index">
                <div class="service-row">
                    <div class="form-group service-name-full">
                        <label>Servicio incluido:</label>
                        <input type="text" [(ngModel)]="servicio.service"
                            placeholder="Ej: Tour de Avistamiento de Aves, Senderismo Ecológico" />
                    </div>
                    <div class="service-actions-row">
                        <button type="button" class="btn btn-sm btn-danger" (click)="eliminarServicioIncluido(i)">
                            🗑️ Eliminar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mensaje cuando no hay servicios incluidos -->
        <div class="no-services" *ngIf="serviciosAdicionalesIncluidos.length === 0">
            <div class="no-services-icon">✨</div>
            <p>No has agregado servicios incluidos</p>
            <p class="text-muted">Los servicios incluidos agregan valor sin costo extra</p>
        </div>
    </div>

    <!-- Sección de Habitaciones -->
    <div class="DatosHabitaciones">
        <h2>Habitaciones</h2>
        <p class="section-description">Agrega las habitaciones disponibles para este alojamiento</p>

        <!-- Formulario para añadir habitación -->
        <div class="habitacion-form">
            <div class="form-group">
                <label>Número de habitación:</label>
                <input type="number" [(ngModel)]="nuevaHabitacion.number" min="1" placeholder="Ej: 101" />
            </div>
            <div class="form-group">
                <label>Tipo:</label>
                <input type="text" [(ngModel)]="nuevaHabitacion.type" placeholder="Ej: Suite ecológica deluxe" />
            </div>
            <div class="form-group">
                <label>Piso:</label>
                <input type="number" [(ngModel)]="nuevaHabitacion.floor" min="1" placeholder="Ej: 1" />
            </div>
            <div class="form-group">
                <label>Camas:</label>
                <input type="number" [(ngModel)]="nuevaHabitacion.beds" min="1" placeholder="Ej: 2" />
            </div>
            <div class="form-group">
                <label>Baños:</label>
                <input type="number" [(ngModel)]="nuevaHabitacion.bathroom" min="1" placeholder="Ej: 1" />
            </div>
            <div class="form-group">
                <label>Precio por noche ($):</label>
                <input type="number" [(ngModel)]="nuevaHabitacion.price_per_night" min="0" placeholder="Ej: 280" />
            </div>

            <!-- Subida de imágenes de habitación -->
            <div class="form-group">
                <label>Imágenes de la habitación:</label>
                <input type="file" multiple accept="image/*" (change)="onHabitacionFilesSelected($event)" />
                <div class="habitacion-upload-info">Formatos: JPG, PNG, WebP • Máx: 5MB</div>
                <div *ngIf="imagenesHabitacionCargando" class="habitacion-cargando">Subiendo imágenes...</div>
                <div *ngIf="imagenesHabitacionError" class="habitacion-error">{{imagenesHabitacionError}}</div>
                <div class="habitacion-images-preview" *ngIf="imagenesHabitacionPreview.length > 0">
                    <div class="habitacion-image-item" *ngFor="let img of imagenesHabitacionPreview">
                        <img [src]="img" alt="Preview" />
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-primary" (click)="agregarHabitacion()">➕ Añadir habitación</button>
        </div>

        <!-- Lista de habitaciones añadidas -->
        <div class="habitaciones-list" *ngIf="habitaciones.length > 0">
            <h3>Habitaciones añadidas ({{habitaciones.length}})</h3>
            <div class="habitacion-item" *ngFor="let hab of habitaciones; let i = index">
                <div class="habitacion-info">
                    <strong>#{{hab.number}}</strong> - {{hab.type}} | Piso: {{hab.floor}} | Camas: {{hab.beds}} | Baños:
                    {{hab.bathroom}} | ${{hab.price_per_night}}/noche
                </div>
                <div class="habitacion-images-mini" *ngIf="hab.images && hab.images.length">
                    <img *ngFor="let img of hab.images" [src]="img" alt="img" class="habitacion-mini-img" />
                </div>
                <button type="button" class="btn btn-sm btn-danger" (click)="eliminarHabitacion(i)">🗑️
                    Eliminar</button>
            </div>
        </div>
        <div class="no-habitaciones" *ngIf="habitaciones.length === 0">
            <div class="no-habitaciones-icon">🛏️</div>
            <p>No has agregado habitaciones aún</p>
            <p class="text-muted">Agrega habitaciones para que los huéspedes puedan reservarlas</p>
        </div>
    </div>

        <!-- Sección de Métodos de Pago Disponibles -->
    <div class="DatosMetodosPago">
        <h2>Métodos de Pago Disponibles</h2>
        <p class="section-description">Selecciona los métodos de pago que aceptas para reservas</p>
        <div class="form-group">
            <label for="metodoPagoSelect">Agregar método de pago:</label>
            <select id="metodoPagoSelect" [(ngModel)]="metodoPagoTemp">
                <option value="">Seleccione...</option>
                <option *ngFor="let metodo of metodosPagoDisponibles" [value]="metodo" [disabled]="metodosPagoSeleccionados.includes(metodo)">{{metodo}}</option>
            </select>
            <button type="button" class="btn btn-primary" (click)="agregarMetodoPago(metodoPagoTemp); metodoPagoTemp=''" [disabled]="!metodoPagoTemp || metodosPagoSeleccionados.includes(metodoPagoTemp)">Agregar</button>
        </div>
        <div class="metodos-pago-list" *ngIf="metodosPagoSeleccionados.length > 0">
            <h3>Métodos seleccionados</h3>
            <div class="metodo-pago-item" *ngFor="let metodo of metodosPagoSeleccionados; let i = index">
                <span>{{metodo}}</span>
                <button type="button" class="btn btn-sm btn-danger" (click)="eliminarMetodoPago(i)">🗑️ Eliminar</button>
            </div>
        </div>
        <div class="no-metodos-pago" *ngIf="metodosPagoSeleccionados.length === 0">
            <div class="no-metodos-pago-icon">💳</div>
            <p>No has seleccionado métodos de pago aún</p>
            <p class="text-muted">Agrega al menos uno para que los huéspedes sepan cómo pueden pagar</p>
        </div>
    </div>

        <!-- Sección de Reglas del Alojamiento -->
    <div class="DatosReglas">
        <h2>Reglas del Alojamiento</h2>
        <p class="section-description">Agrega reglas o políticas importantes para los huéspedes (opcional)</p>
        <div class="form-group">
            <label for="reglaTitle">Título de la regla:</label>
            <input id="reglaTitle" type="text" [(ngModel)]="nuevaRegla.title" placeholder="Ej: Política de mascotas" />
        </div>
        <div class="form-group">
            <label for="reglaCategoria">Categoría:</label>
            <input id="reglaCategoria" type="text" [(ngModel)]="nuevaRegla.category" placeholder="Ej: convivencia, seguridad..." />
        </div>
        <div class="form-group">
            <label for="reglaDescripcion">Descripción:</label>
            <textarea id="reglaDescripcion" [(ngModel)]="nuevaRegla.description" placeholder="Describe la regla o política"></textarea>
        </div>
        <div class="form-group">
            <label for="reglaPenalidad">Penalidad (opcional):</label>
            <input id="reglaPenalidad" type="text" [(ngModel)]="nuevaRegla.penalty" placeholder="Ej: Cargo adicional, advertencia..." />
        </div>
        <div class="form-group">
            <label for="reglaStatus">Estado:</label>
            <select id="reglaStatus" [(ngModel)]="nuevaRegla.status">
                <option value="active">Activa</option>
                <option value="inactive">Inactiva</option>
            </select>
        </div>
        <button type="button" class="btn btn-primary" (click)="agregarRegla()" [disabled]="!nuevaRegla.title || !nuevaRegla.description">➕ Añadir regla</button>

        <div class="reglas-list" *ngIf="reglas.length > 0">
            <h3>Reglas añadidas ({{reglas.length}})</h3>
            <div class="regla-item" *ngFor="let regla of reglas; let i = index">
                <div class="regla-info">
                    <strong>{{regla.title}}</strong> <span class="regla-categoria">({{regla.category}})</span> - <span class="regla-status" [ngClass]="{'activa': regla.status === 'active', 'inactiva': regla.status === 'inactive'}">{{regla.status === 'active' ? 'Activa' : 'Inactiva'}}</span>
                    <div class="regla-desc">{{regla.description}}</div>
                    <div class="regla-penalidad" *ngIf="regla.penalty"><strong>Penalidad:</strong> {{regla.penalty}}</div>
                </div>
                <button type="button" class="btn btn-sm btn-danger" (click)="eliminarRegla(i)">🗑️ Eliminar</button>
            </div>
        </div>
        <div class="no-reglas" *ngIf="reglas.length === 0">
            <div class="no-reglas-icon">📜</div>
            <p>No has agregado reglas aún</p>
            <p class="text-muted">Puedes dejar este campo vacío si no tienes reglas específicas</p>
        </div>
    </div>

    <!-- Formulario Ubicacion -->
    <div class="map-container">
        <h2>Configuración de Ubicación</h2>

        <div class="ubicacion-buttons">
            <button type="button" class="btn btn-success" (click)="obtenerUbicacionGPS()">
                📱 Usar GPS
            </button>
        </div>
        <!-- Coordenadas manuales -->
        <div class="coordenadas-manuales">
            <h3>Coordenadas manuales</h3>
            <div class="coords-row">
                <div class="coord-input">
                    <label>Latitud:</label>
                    <input type="number" step="any" [(ngModel)]="ubicacionData.latitud" placeholder="Ej: 4.7110" />
                </div>
                <div class="coord-input">
                    <label>Longitud:</label>
                    <input type="number" step="any" [(ngModel)]="ubicacionData.longitud" placeholder="Ej: -74.0721" />
                </div>
                <button type="button" class="btn btn-primary" (click)="aplicarLatLngEnMapa()">
                    Aplicar coordenadas
                </button>
            </div>
        </div>
        <!-- Mapa interactivo -->
        <div class="mapa-header">
            <label>Mapa interactivo:</label>
            <button type="button" class="help-toggle" (click)="toggleAyuda('mapa')" title="Ayuda mapa">?</button>
            <div class="ayuda-contextual mapa-ayuda" *ngIf="ayudaVisible.mapa">
                <div class="ayuda-overlay" (click)="cerrarTodasLasAyudas()"></div>
                <div class="ayuda-content">
                    <h6>Mapa Interactivo</h6>
                    <ul>
                        <li>Haz clic en el mapa para seleccionar ubicación</li>
                        <li>Arrastra el marcador para ajustar posición</li>
                        <li>Usa zoom para mayor precisión</li>
                        <li>Las coordenadas se actualizan automáticamente</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="mapa-amazon-admin">
            <app-mapa-direccion [initialLat]="coordenadasSeleccionadas.lat" [initialLng]="coordenadasSeleccionadas.lng"
                (coordenadas)="onCoordenadasSeleccionadas($event)">
            </app-mapa-direccion>
        </div>
        <!-- Resultado de ubicación -->
        <div class="ubicacion-resultado">
            <label>Ubicación seleccionada:</label>
            <input type="text" [(ngModel)]="ubicacionData.ubicacion" readonly
                placeholder="Selecciona una ubicación arriba" />
        </div>

        <!-- Dirección exacta -->
        <div class="direccion-exacta">
            <label>Dirección exacta:</label>
            <textarea [(ngModel)]="ubicacionData.direccion" required placeholder="Ej: Calle 123 #45-67"></textarea>
        </div>
    </div>
        <!-- Botón para crear o actualizar alojamiento -->
    <div class="crear-alojamiento-container">
        <button type="button" class="btn btn-success btn-lg" (click)="enviarDatos()">
            <ng-container *ngIf="isEditMode; else crear">
                💾 Actualizar datos
            </ng-container>
            <ng-template #crear>
                🏡 Crear alojamiento
            </ng-template>
        </button>
        <button *ngIf="isEditMode" type="button" class="btn btn-secondary btn-lg" style="margin-left:1rem" (click)="cancelarEdicion()">
            Cancelar
        </button>
    </div>

</div>
